import {
	CLEAR,
	ERROR,
	SUCCESS,
	LOADING,
	LOGGING,
	LOGIN, LOGOUT, GET_USERS
} from "./usersActionsCreator";

const defaultState = {
	ready: false,
	isLogged: false,
	loading: false,
	list: []
};

export default function userReducer(state = defaultState, action) {
	switch (action.type) {
		case LOGIN:
			return {
				...state,
				ready: true,
				isLogged: true,
				data: action.data
			};
		case LOGOUT:
			return {
				ready: true,
				isLogged: false,
				loading: false,
				list: []
			};
		case LOADING: {
			return {
				...state,
				loading: action.data
			};
		}
		case GET_USERS: {
			return {
				...state,
				list: action.data,
				loading: false
			};
		}
		case ERROR: {
			return {
				...state,
				loading: false,
				ready:true,
				error: action.data
			};
		}
		case SUCCESS: {
			return {
				...state,
				loading: false,
				success: true
			};
		}
		case CLEAR: {
			return {
				...state,
				loading: false,
				success: false,
				error: null
			};
		}
		default: return state;
	}
}